import { ThemeProvider as MuiThemeProvider, getTheme } from '@nexelem/deprecated-theme';
import { ReactNode } from 'react';
import { EmotionCacheProvider } from './EmotionCacheProvider';

type ThemeProviderProps = {
  readonly children: ReactNode;
};
export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const theme = getTheme();

  return (
    <EmotionCacheProvider>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </EmotionCacheProvider>
  );
};
